import { CommonModule } from '@angular/common';
import { Component, ComponentRef, ElementRef,
  EventEmitter, HostListener, OnInit, Output,
  ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HtmlErrorComponent } from 'src/app/fragments/html-error/html-error.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MssServiceFactory, MssTypeService } from 'src/app/services/mss/mss-service.factory';

@Component({
  selector: 'app-relevage-apicrypt',
  templateUrl: './relevage-apicrypt.component.html',
  styleUrls: [
    './relevage-apicrypt.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ],
})
export class RelevageApicryptComponent implements OnInit {
  public header: string = '';
  public msg: string = '';
  public list: string[] = [];

  public relevageLu: boolean = true;
  public suppressionApresRelevage: boolean = true;

  @Output() public closeEmitter = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  toggleOptionRelevageLu() {
    this.relevageLu = !this.relevageLu;
  }

  toggleOptionSuppressionApresRelevage() {
    this.suppressionApresRelevage = !this.suppressionApresRelevage;
  }

  public closeConfirmationModal(): void {
    this.closeEmitter.emit(false);
  }

  public confirmAction() {
    this.closeEmitter.emit({relevageLu:this.relevageLu, suppressionApresRelevage:this.suppressionApresRelevage});
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
